function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "avatar-kyo-2x-a",
  width: 95,
  height: 95,
  rx: 22
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "avatar-kyo-2x-b",
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7DD1E8",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4DBDEA",
  offset: "53.257%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#18BDEB",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "avatar-kyo-2x-c",
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#avatar-kyo-2x-a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#avatar-kyo-2x-a"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#avatar-kyo-2x-b)",
  mask: "url(#avatar-kyo-2x-c)",
  d: "M70.886 6.5H24.114c-.81 0-1.606.057-2.387.165-.424.058-.644.538-.418.9 1.725 2.777 4.702 7.852 7.415 13.9.23.512.933.575 1.246.11 1.027-1.516 1.775-2.91 2.188-4.06.22-.607.803-1.005 1.45-1.005h5.165c.635 0 1.102.598.943 1.213-.713 2.762-2.307 7.493-6.713 12.884-.338.415-.445.97-.29 1.484 3.31 11.053 4.225 22.432 3.718 32.068-.568 10.815-3.658 15.53-8.456 16.263-3.404.52-7.177.548-9.08.52-.693-.01-1.246-.573-1.246-1.265V74.27c0-.685.544-1.246 1.226-1.266 4.43-.13 7.324-1.023 8.37-3.56.735-1.788 1.537-6.433 1.09-14.042-.036-.63-.81-.905-1.24-.444-3.184 3.418-7.396 6.942-9.65 8.76-.637.514-1.585.06-1.585-.76v-6.5c0-.376.17-.732.46-.973 4.754-3.965 7.987-7.886 9.853-10.46.506-.7.704-1.573.548-2.42-.14-.768-.29-1.55-.453-2.352-.097-.477-.2-.953-.308-1.428-.115-.503-.71-.726-1.123-.417-3.4 2.54-6.143 3.786-7.665 4.353-.637.238-1.313-.233-1.313-.913v-6.554c0-.446.232-.86.617-1.086 2.128-1.25 4.134-2.726 5.962-4.3.4-.346.548-.904.36-1.4-2.98-7.857-6.705-14.445-8.803-17.884-.21-.344-.677-.425-.99-.17C9.04 13.685 6.5 18.608 6.5 24.113v46.772c0 9.73 7.886 17.615 17.614 17.615h46.772c9.728 0 17.614-7.886 17.614-17.614V24.114C88.5 14.386 80.614 6.5 70.886 6.5zm9.384 70.486c0 .812-.658 1.47-1.47 1.47H41.223c-.812 0-1.47-.658-1.47-1.47V71.97c0-.81.658-1.47 1.47-1.47h12.602c.812 0 1.47-.657 1.47-1.47V53.026c0-.812-.658-1.47-1.47-1.47h-9.57c-.813 0-1.47-.658-1.47-1.47v-4.703c0-.812.657-1.47 1.47-1.47h9.57c.812 0 1.47-.658 1.47-1.47V27.818c0-.81-.658-1.47-1.47-1.47H43.51c-.81 0-1.47-.658-1.47-1.47v-4.703c0-.812.66-1.47 1.47-1.47h33c.813 0 1.47.658 1.47 1.47v4.703c0 .812-.657 1.47-1.47 1.47H65.873c-.812 0-1.47.66-1.47 1.47v14.624c0 .812.658 1.47 1.47 1.47h9.897c.81 0 1.47.658 1.47 1.47v4.703c0 .812-.66 1.47-1.47 1.47H65.87c-.812 0-1.47.658-1.47 1.47V69.03c0 .813.658 1.47 1.47 1.47H78.8c.812 0 1.47.66 1.47 1.47v5.016z"
}));

var SvgKyoDark = function SvgKyoDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKyoDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kyo-dark.b0e76c7a.svg";
export { ForwardRef as ReactComponent };